import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ark-lib-moderate-modal',
  templateUrl: './moderate-modal.component.html',
  styleUrls: ['./moderate-modal.component.css'],
})
export class ModerateModalComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
